import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";

const NotFoundComponent = () => {
  const phrases = useSelector((state: RootState) => state.phrases.value);
  
  useEffect(() => {
    document.title = phrases[37];
  }, [phrases]);
    
  return <section>
    <p>The page is not found.</p>
  </section>
}

export default NotFoundComponent
